import React from 'react';

type Props = {
    id      :  ID
    title   :  string
    close   :  callback
    fadeTime: number
}

export default function CustomerCreated(props: Props){

    const open = () => {
        gd.goTo('crm/contact/{0}'.f(props.id))
        props.close();
    }

    const copyLink = () => {
        const url = 'https://www.goodday.work/crm/contact/{0}'.f(props.id);
        gd.utils.copyToClipboard(url);
        gd.growl.success("Link copied to clipboard");
        props.close();
    }

    const classes = Classes("notification", "create", "h-60")

    return (
        <div className={classes} style={{transition: "opacity " + props.fadeTime + "s"}}>
            <div className="flex-row-left-top">
                <div className="left-indicator h-60">
                    <div className="i5-done ui5-color-green fs-15 create-icon"/>
                </div>
                <div className="right-content">
                    <div className="ui5-txt-not-important-small m-b-8">Customer created</div>
                    <div
                        className="ui5-txt-less-important-small txt-truncate max-w-225 m-b-8">{props.title}</div>
                    <div className="flex-row-between-center">
                        {props.id && (
                            <div className="flex-row-left-center">
                                <div className="flex-row-left-center link m-r-20" onClick={open}>
                                    <div className="i5-open-new-window m-r-5"></div>
                                    <div className="ui5-txt-link-tiny">Open</div>
                                </div>

                                <div className="flex-row-left-center link" onClick={copyLink}>
                                    <div className="i5-link m-r-5"></div>
                                    <div className="ui5-txt-link-tiny">Copy link</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="close i5-delete" onClick={props.close}/>
        </div>
    )
}
